import { INTERVIEW_ROOM_PROVIDERS, INTERVIEW_STEP_FORM_TYPES } from './constants';
export const resolveStepId = (queryStepId, meeting) => {
    const fromQuery = Number(queryStepId);
    if (queryStepId && Number.isInteger(fromQuery) && fromQuery > 0) {
        return fromQuery;
    }
    return meeting?.workflow_candidate_step?.step_id ?? null;
};
// "Pending" = the saga found a pre-interview form the candidate has not submitted yet, and added its formId.
export const getPendingPreInterviewFormId = (response) => {
    if (typeof response !== 'object' || response === null || !('formId' in response)) {
        return null;
    }
    const { formId } = response;
    return typeof formId === 'number' && formId > 0 ? formId : null;
};
export const findStepFormId = (stepForms, stepFormType) => stepForms?.find((stepForm) => stepForm.step_form_type === stepFormType)?.form?.id ?? null;
// The step's own post-interview form wins; the tenant-wide GrowthBook flag is only a fallback.
export const resolvePostInterviewFormId = (stepForms, flagValue) => {
    const stepFormId = findStepFormId(stepForms, INTERVIEW_STEP_FORM_TYPES.POST);
    if (stepFormId) {
        return stepFormId;
    }
    const flagFormId = Number(flagValue);
    return Number.isInteger(flagFormId) && flagFormId > 0 ? flagFormId : null;
};
// The room embeds in an iframe and tells the parent window when the participant leaves.
export const shouldListenForLeave = (providerName, hasIframe) => Boolean(hasIframe) || INTERVIEW_ROOM_PROVIDERS.includes(providerName ?? '');
export const isInterviewLeaveMessage = (message) => {
    if (typeof message !== 'object' || message === null) {
        return false;
    }
    const read = (key) => Reflect.get(message, key);
    return Boolean(read('IRleaveBtnClick') ||
        read('leaveMeeting') ||
        read('type') === 'IRleaveBtnClick' ||
        read('type') === 'IRleaveByParticipant' ||
        read('raw') === 'IRleaveBtnClick');
};
